import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type DedupModalResult = 'resend_all' | 'exclude_contacted' | null;

export interface DedupWarningModalData {
    previously_contacted: number;
    total_members: number;
    never_contacted: number;
}

@Component({
    selector: 'app-dedup-warning-modal',
    templateUrl: './dedup-warning-modal.component.html',
    styleUrls: ['./dedup-warning-modal.component.scss'],
    standalone: false
})
export class DedupWarningModalComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DedupWarningModalData,
        private readonly dialogRef: MatDialogRef<DedupWarningModalComponent, DedupModalResult>
    ) {}

    resendToAll(): void {
        this.dialogRef.close('resend_all');
    }

    sendToNewOnly(): void {
        this.dialogRef.close('exclude_contacted');
    }

    cancel(): void {
        this.dialogRef.close(null);
    }
}
